import { Injectable, EventEmitter } from "@angular/core";

@Injectable()
export class ThemeService {
    animationState = "in";
    disableMenuOpen = new EventEmitter<any>();
    enableMenuOpen = new EventEmitter<any>();

    public toggleMenu() {
        this.animationState = this.animationState === "in" ? "out" : "in";
    }
}